import { type FC, useCallback, useEffect, useState } from 'react'
import { secondsToTime } from 'shared/lib/secondsToTime.ts'
import { Typography } from 'shared/ui'
import styles from './styles.module.scss'

type IAudioProcessingProps = {
  loading: boolean
  duration: number
  setDuration?: (value: number) => void
  hideProgressLabel?: boolean
}

export const AudioProcessing: FC<IAudioProcessingProps> = ({
  duration,
  loading,
  setDuration,
  hideProgressLabel,
}) => {
  const [time, setTime] = useState(duration)

  useEffect(() => {
    if (duration) {
      setTime(duration)
      setDuration?.(duration)

      return
    }
  }, [duration])

  const renderState = useCallback(() => {
    if (loading) return hideProgressLabel ? '' : 'Processing...'
    if (!time) return '0:00'

    return secondsToTime(time)
  }, [loading, time, hideProgressLabel])

  return (
    <Typography
      variant={'body-md-regular'}
      width={time > 0 ? 36 : 84}
      className={styles.duration}
      tag={'div'}
      ariaLabel={'time'}
    >
      {renderState()}
    </Typography>
  )
}
